import { Box, Container, Link, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Logo } from "../../components";
import { Outlet } from "react-router-dom";

export const PromotionLayout = () => {
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down("md"));
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box mb={{ xs: 4, md: 8 }}>
          <Logo height={23} />
        </Box>

        <Outlet />
      </Container>

      <Box
        component="footer"
        sx={{
          minHeight: "72px",
          background: "#F6F6F6",
          mt: "auto", // Pushes the footer to the bottom
          display: "flex",
          alignItems: "center",
          paddingY: "16px",
        }}
      >
        <Container maxWidth="lg">
          <Box
            display="flex"
            flexDirection={mdDown ? "column" : "row"}
            justifyContent={mdDown ? "space-around" : "space-between"}
            alignItems="center"
            gap="16px"
          >
            <Typography
              sx={{ fontWeight: 400, fontSize: "15px", textAlign: "center" }}
            >
              SellerScout @ 2026, All rights reserved
            </Typography>

            <Stack
              alignItems="center"
              direction={smDown ? "column" : "row"}
              gap="16px"
            >
              <Link
                href="https://www.sellerscout.com/terms"
                sx={{ fontWeight: "700", fontSize: "15px", color: "#0E0E0F" }}
                underline="none"
              >
                Terms & Conditions
              </Link>
              <Link
                href="https://www.sellerscout.com/privacy"
                sx={{ fontWeight: "700", fontSize: "15px", color: "#0E0E0F" }}
                underline="none"
              >
                Privacy Policy
              </Link>
              <Link
                href="https://www.sellerscout.com/refund-cancellation"
                sx={{ fontWeight: "700", fontSize: "15px", color: "#0E0E0F" }}
                underline="none"
              >
                Refund & Cancellation
              </Link>
            </Stack>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default PromotionLayout;
